export enum AdEventType {
  ImpressionViewable = 'impressionViewable',
  SlotOnLoad = 'slotOnload',
  SlotRenderEnded = 'slotRenderEnded',
  SlotRequested = 'slotRequested',
  SlotResponseReceived = 'slotResponseReceived',
  SlotVisibilityChanged = 'slotVisibilityChanged',
}
